import { createContext } from 'react'
import { ListState } from '@react-stately/list'

export const ListBoxContext = createContext<ListState<object> | null>(null)
